import React from 'react';
import { PortableText } from '@portabletext/react';
import { bgColorClassname } from '@/utils';
import type { PortableTextBlock } from '@sanity/types';
import { Heading } from '@/components';
import FSFormEmbed from './FSFormEmbed';

// Define the interface for the component props
interface FormstackEmbedProps {
  title: string;
  content: PortableTextBlock[];
  formstackID: string;
  backgroundColor?: {
    label: string;
    value: string;
  };
}

// Define the functional component with props
const FormstackEmbed: React.FC<FormstackEmbedProps> = ({
  title,
  content,
  formstackID,
  backgroundColor,
}) => {
  return (
    <div className={backgroundColor ? bgColorClassname(backgroundColor) : ''}>
      <div className='font-halyarddisplay mx-auto flex max-w-screen-xl flex-col gap-x-6 px-5 py-8 md:p-[50px]'>
        {title && <Heading title={title} />}
        {content && <PortableText value={content} />}
        {formstackID && <FSFormEmbed formstackID={formstackID} />}
      </div>
    </div>
  );
};

export default FormstackEmbed;
